"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _MenuItem = _interopRequireDefault(require("@material-ui/core/MenuItem"));

var _Select = _interopRequireDefault(require("@material-ui/core/Select"));

var _Checkbox = _interopRequireDefault(require("@material-ui/core/Checkbox"));

var _ListItemText = _interopRequireDefault(require("@material-ui/core/ListItemText"));

var _Input = _interopRequireDefault(require("@material-ui/core/Input"));

var _Chip = _interopRequireDefault(require("@material-ui/core/Chip"));

var _commonField = _interopRequireDefault(require("./common-field"));

var _attach = _interopRequireDefault(require("../attach"));

var _withStyles = _interopRequireDefault(require("@material-ui/core/styles/withStyles"));

var _displayValueTypography = _interopRequireDefault(require("./display-value-typography"));

var _autocompleteSelect = _interopRequireDefault(require("./autocomplete-select"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var styles = function styles(theme) {
  return {
    formControl: {
      // Specify a more appropriate min width so that the field is wide enough to cover most labels
      minWidth: 120
    },
    chip: {
      margin: theme.spacing(0.25)
    }
  };
};

var SelectField = /*#__PURE__*/function (_React$PureComponent) {
  (0, _inherits2.default)(SelectField, _React$PureComponent);

  var _super = _createSuper(SelectField);

  function SelectField() {
    var _this;

    (0, _classCallCheck2.default)(this, SelectField);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      focus: false
    });
    return _this;
  }

  (0, _createClass2.default)(SelectField, [{
    key: "handleChange",
    value: function handleChange(value) {
      this.props.component.setValue(value);
    }
  }, {
    key: "handleAutocompleteChange",
    value: function handleAutocompleteChange(value) {
      var multiple = this.props.multiple;

      if (multiple) {
        this.handleChange(value ? value.map(function (val) {
          return val.value;
        }) : null);
      } else {
        this.handleChange(value && (value.value ? value.value : null));
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        focus: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        focus: false
      });
      this.props.component.setTouched(true);
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var _this$props = this.props,
          options = _this$props.options,
          blankString = _this$props.blankString,
          value = _this$props.value,
          multiple = _this$props.multiple;

      if (options) {
        var opts = [];

        if (!multiple && blankString) {
          // Note: the blankString doesn't make sense when we allow multiple selections
          opts.push( /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
            value: "",
            key: ""
          }, /*#__PURE__*/_react.default.createElement("em", null, blankString)));
        }

        options.forEach(function (option) {
          if (multiple) {
            var checked = value ? value.indexOf(option.value) !== -1 : false;
            opts.push( /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
              value: option.value,
              key: option.value
            }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
              checked: checked
            }), /*#__PURE__*/_react.default.createElement(_ListItemText.default, {
              primary: option.label
            })));
          } else {
            opts.push( /*#__PURE__*/_react.default.createElement(_MenuItem.default, {
              value: option.value,
              key: option.value
            }, option.label));
          }
        });
        return opts;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          value = _this$props2.value,
          err = _this$props2.err,
          touched = _this$props2.touched,
          disabled = _this$props2.disabled,
          component = _this$props2.component,
          fullWidth = _this$props2.fullWidth,
          classes = _this$props2.classes,
          editable = _this$props2.editable,
          multiple = _this$props2.multiple,
          accessEditable = _this$props2.accessEditable,
          useDisplayValue = _this$props2.useDisplayValue,
          options = _this$props2.options,
          autocomplete = _this$props2.autocomplete;
      var focus = this.state.focus;
      var dis = accessEditable === false || disabled;
      var fieldValue = multiple ? [] : '';

      if (value) {
        fieldValue = value;
      }

      var input = undefined;
      var renderValue = undefined;

      if (multiple) {
        input = /*#__PURE__*/_react.default.createElement(_Input.default, null);

        renderValue = function renderValue(selected) {
          return /*#__PURE__*/_react.default.createElement("div", {
            className: classes.chips
          }, selected.map(function (value) {
            return /*#__PURE__*/_react.default.createElement(_Chip.default, {
              key: value,
              label: component.getOptionLabel(value),
              className: classes.chip
            });
          }));
        };
      }

      var optionalProps = {};
      var fld = null;
      var ariaLabel = component.get('label');

      if (editable && !useDisplayValue) {
        if (autocomplete) {
          var autocompleteValue = null;

          if (multiple) {
            autocompleteValue = fieldValue.map(function (value) {
              return {
                value: value,
                label: component.getOptionLabel(value)
              };
            });
          } else {
            autocompleteValue = {
              value: fieldValue,
              label: component.getOptionLabel(fieldValue)
            };
          } // Shrink the label?


          if (focus || !component.isValueBlank(fieldValue)) {
            optionalProps.shrinkLabel = true;
          }

          fld = /*#__PURE__*/_react.default.createElement(_autocompleteSelect.default, {
            id: component.getUniqueId(),
            options: options,
            isClearable: true,
            placeholder: "",
            onChange: function onChange(value) {
              return _this2.handleAutocompleteChange(value);
            },
            onBlur: function onBlur() {
              return _this2.handleBlur();
            },
            onFocus: function onFocus() {
              return _this2.handleFocus();
            },
            value: autocompleteValue,
            isDisabled: dis,
            fullWidth: fullWidth,
            isMulti: multiple,
            "aria-label": ariaLabel
          });
        } else {
          fld = /*#__PURE__*/_react.default.createElement(_Select.default, {
            id: component.getUniqueId(),
            multiple: multiple,
            error: touched && err ? true : false,
            onChange: function onChange(event) {
              return _this2.handleChange(event.target.value);
            },
            onBlur: function onBlur() {
              return _this2.handleBlur();
            },
            input: input,
            renderValue: renderValue,
            value: fieldValue,
            disabled: dis,
            fullWidth: fullWidth,
            className: classes.formControl,
            "aria-label": ariaLabel
          }, this.renderOptions());
        }
      } else {
        var displayValue = null;

        if (multiple && value) {
          displayValue = value.map(function (val) {
            return /*#__PURE__*/_react.default.createElement(_Chip.default, {
              key: val,
              label: component.getOptionLabel(val),
              className: classes.chip
            });
          });
        } else {
          displayValue = component.getDisplayValue();
        }

        fld = /*#__PURE__*/_react.default.createElement(_displayValueTypography.default, {
          "aria-label": ariaLabel
        }, displayValue);
      }

      return /*#__PURE__*/_react.default.createElement(_commonField.default, (0, _extends2.default)({
        component: component
      }, optionalProps), fld);
    }
  }]);
  return SelectField;
}(_react.default.PureComponent);

SelectField = (0, _withStyles.default)(styles)(SelectField);

var _default = (0, _attach.default)(['value', 'err', 'options', 'touched', 'blankString', 'disabled', 'fullWidth', 'editable', 'multiple', 'useDisplayValue', 'autocomplete'])(SelectField);

exports.default = _default;